<template>
  <div
    :class="{'lk-page-background': router.currentRoute.value.fullPath === '/lk'}"
    class="visualizer-header"
  >
    <div
      id="visualizer-header"
      class="left-side"
    />

    <div class="right-side">
      <HeaderUserProfile />
    </div>


    <LogoutDialog
      :show="store.isShowLogoutDialog"
      @close-dialog="store.isShowLogoutDialog = false"
    />
  </div>
</template>

<script setup>
import LogoutDialog from "@/components/GlobusHeader/LogoutDialog.vue";
import {useStore} from "@/store";
import {useRouter} from "vue-router";
import HeaderUserProfile from "@/components/VisualizerHeader/HeaderUserMenu/HeaderUserProfile.vue";

const store = useStore();
const router = useRouter();

</script>

<style lang="scss" scoped>


.visualizer-header {
  position: relative;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 3px 6px;

  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 0 20px 0 #4C62782E;

  .left-side {
    display: flex;
    gap: 6px;
    align-items: center;
  }

  .right-side {
    display: flex;
    align-items: center;
  }

  &__logo {
    width: 34px;
    height: 34px;
  }
}
</style>
